<div class="container">

<h1 class="header-title">
  <span class="back" (click)="onBack()">
    <flame-icon svgIcon="chevron-left" />
  </span>
  {{ textTokens?.CAPTURA_TOP_BAR_TITLE}}
</h1>

<app-select-account
  [title]="textTokens?.CAPTURA_SELECT_ACCOUNT"
  [account]="recharge.accountSelected"
  [accounts]="accounts"
  (OnAccountSelected)="getAccountSelected($event)"
></app-select-account>

<app-cell-phone-directory
  [formTitle]="textTokens?.CAPTURA_PHONE_NUMBER_LABEL"
  [formPlaceholder]="'00 0000 0000'"
  [openDirectory]="openDirectory"
  [showDirectory]="showDirectory"
  [setPhone]="recharge.phone"
  (onPhoneValue)="getPhone($event)"
></app-cell-phone-directory>

<app-telephone-companies
  [title]="textTokens?.CAPTURA_SELECT_COMPANY"
  [viewSkeleton]="!!successBillers"
  [company]="recharge.biller"
  (click)="onCompanies()"
></app-telephone-companies>

<app-select-amount
  [amount]="recharge.amount"
  [enable]="!!recharge.biller"
  (showConsiderations)="showConsiderations($event)"
  (showAmounts)="selectAmount()"
  [showError]="errorAmount"
></app-select-amount>

<app-panel-schedule
  [recharges]="arrayDetailsRecharge"
  (eventEditSchedule)="editPaymentSchesule()"
  [activeEditRecharge]="activeBtn"
  (setPaymentSchedule)="activeStatusSchedule($event)"
>
</app-panel-schedule>

<div class="btn-container">
  <button
    flameButton
    color="primary"
    [disabled]="!activeBtn"
    (click)="continue()"
  > 
    {{textTokens?.BUTTON_CONFIRM}} 
  </button>
</div>
</div>




